export const DEFAULT_QUANTITY = 1;
export const PRODUCT_DETAILS_CLASS = 'of-product-details';
